import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface SupplierSearchResult {
    _id: string;
    title: string;
    isDealer: boolean;
    formattedAddress?: string;
}

interface SupplierSearchResponse {
    suppliers: Array<SupplierSearchResult>;
}

const searchSuppliers = async (sessionId: string, searchTerm: string): Promise<SupplierSearchResponse> => {
    const { data } = await axios.get(`${API_URL}/supplier/search`,
        {
            headers: {
                Authorization: sessionId
            },
            params: {
                searchTerm
            }
        }
    );
    return data;
};

export interface UseSearchSuppliersOptions {
    /** Fetch full org supplier list with empty searchTerm. */
    listAll?: boolean;
}

export const useSearchSuppliers = (
    searchTerm: string,
    options?: UseSearchSuppliersOptions,
) => {
    const sessionContext = useContext(SessionContext);
    const listAll = options?.listAll ?? false;
    const queryTerm = listAll ? '' : searchTerm;

    const queryKey = listAll
        ? (['/supplier/search', 'listAll'] as const)
        : (['/supplier/search', queryTerm] as const);

    const enabled =
        !!sessionContext?.sessionId && (listAll || searchTerm.length > 2);

    return useQuery({
        queryKey,
        queryFn: () => searchSuppliers(sessionContext?.sessionId ?? '', queryTerm),
        enabled,
        staleTime: listAll ? 1000 * 60 * 5 : undefined,
    });
};

export { searchSuppliers };
